import {Component, Input, OnInit, ElementRef, HostBinding} from '@angular/core';

// Services
import {CatalogService} from '../../services/catalog-service';
import {AppService} from '../../../../shared/services/app-service'; // TODO: Decouple
import {CartService} from '../../services/cart-service';

// Classes
import {Product} from '../../classes/product';
import {ProductCategory} from '../../classes/product-category';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductOptionsDropdownCmp'));

@Component({
    selector: 'product-options-dropdown-cmp',
    template: require('./product-options-dropdown.cmp.html'),
    styles: [String(require('./product-options-dropdown.cmp.scss'))],
    host: {
        '(document:click)': '_onClick($event)',
        class: 'product-options-dropdown'
    }
})
export class ProductOptionsDropdownCmp {

    @Input() product: Product;
    @Input() category: ProductCategory;
    @Input() optionsListId;

    @HostBinding( 'class.active' ) _optionsDropdownIsActive: boolean = false;

    private _imgPaths = null;
    private _selectedOption = null;
    private _dropdownElement = null;
    private _optionsDropdownIsRendered: boolean = false;
    // private _optionsDropdownIsActive: boolean = false;

    
    constructor (
        private _elementRef: ElementRef,
        private _catalogService: CatalogService,
        private _appService: AppService, // TODO: Decouple
        private _cartService: CartService
    ) {
        debugOff( 'Construct products options dropdown component' );

        this._imgPaths = this._catalogService.imgPaths;
        this._dropdownElement = _elementRef.nativeElement;
    }

    
    ngOnInit () {
        debugOff( 'Initialise products options dropdown component' );
    }

    
    openOptionDropdown () {
        // '"' + this.product.code + '" - Open "' + this.optionsListId + '" option dropdown' );
        // '"' + this.product.code + '" - Product:', [this.product] );
        if (this._optionsDropdownIsRendered === true) { return; }
        this._selectedOption = this.product.options.selected[this.optionsListId];
        // console.log(this._selectedOption);

        if (this.product.options) {
            this.product.options.dropdownIsActive = true;
            this._appService.state.prodOptionsDropdownIsOpened = true;
        }

        // Add to temporary preview
        this.product.addToScene();

        this._optionsDropdownIsRendered = true;
        setTimeout(() => this._optionsDropdownIsActive = true, 0);
    }

    /** Triggered on option hover
     */
    selectOption (option) {
        // 'Select "' + option + '" from "' + this.optionsListId + '" option dropdown' );
        option !== null && (this.product.options.selected[this.optionsListId] = option);

        // Update product state using the new dynamic options
        this.product.refreshState();

        // Update cart total price, some options may change price (such as finish)
        if (this.product.isAddedToCart === true) {
            this._cartService.updateTotalPrice();
        }
    }

    
    closeOptionDropdown () {
        // 'Close "' + this.optionsListId + '" option dropdown' );
        if (this._optionsDropdownIsRendered === false) { return; }

        if (this.product.options) {
            this.product.options.dropdownIsActive = false;
            this._appService.state.prodOptionsDropdownIsOpened = false;
        }

        // Remove from temporary preview
        this.product.removeFromScene();

        this._optionsDropdownIsActive = false;
        setTimeout(() => this._optionsDropdownIsRendered = false, 300);
    }

    
    private _onOptionClick () {

        debugOff( 'Product option clicked' );

        // Just close dropdown, option was already selected at hover.
        this.closeOptionDropdown();

        // console.log('Product options dropdown: on optio select - Product:', this.product);

        // Add to cart
        this.product.isAddedToCart !== true && this.product.addToCart( this.category.id );

        // Preview product - <!> Disabled because of bad UX
        //this._appService.togglePreview();
        //this.product.addToScene();
        //this.product.displayTooltip();
    }

    
    private _onClick (event) {

        // Prevent option change if dropdown is closed
        if (this._optionsDropdownIsRendered === false) { return; }

        // Close dropdown if click is outside of options list
        if (!this._dropdownElement.contains( event.target )) {

            // Restore selected option if dismissing dropdown
            this.product.options.selected[this.optionsListId] = this._selectedOption;
            this.product.refreshState();
            this.closeOptionDropdown();
        }
        // else {
        //     this.product.addToCart( 'spa-therapies' );
        // }
    }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/products/product-options-dropdown.cmp.ts